export const   option = {
    title: {      //标题组件
        text: '产品周转率'
    },
    tooltip: {    //提示框组件
        trigger: 'axis'
    },
    legend: {     //图例组件
        data: ['出货数量'],
        left:200
    },
    grid: {       //直角坐标系内绘图网格
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    toolbox: {     //工具栏
        feature: {
        }
    },
    xAxis: {       //直角坐标系 grid 中的 x 轴
        type: 'category',
        boundaryGap: false,
        data: [
            '1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'
        ]
    },
    yAxis: {       //直角坐标系 grid 中的 y 轴
        type: 'value',
        data:[
        '20%','50%','20%','30%','22%','10%','60%','20%','27%','20%','29%','88%'
        ]
    },
    series: [      //系列列表
        {
            name: '周转率',
            type: 'line',
            stack: '总量',
            data: []
        }
    ]
 
}